import { fetcher } from "utils";
import { IMembersOrderPoints } from "typings";

export const get__members__order_points = (): Promise<IMembersOrderPoints[]> => fetcher.get("/members/order_points");
